<ion-card *ngIf="container === 'card' else pictureTextTemplate">
    <ion-card-content>
        <ng-container *ngTemplateOutlet="pictureTextTemplate"></ng-container>
    </ion-card-content>
</ion-card>

<ng-template #pictureTextTemplate>
    <img [src]="pictureUrl" alt="" *ngIf="pictureUrl && pictureLoadingMode === 'eager'">
    <ion-img [src]="pictureUrl" alt="" *ngIf="pictureUrl && pictureLoadingMode === 'lazy'"></ion-img>

    <p *ngIf="labelTitle" class="ion-text-center">{{labelTitle | translate}}</p>

    <p *ngIf="labelSubTitle && !labelSubTitleHtml" class="ion-text-center">{{labelSubTitle | translate}}</p>
    <div *ngIf="!labelSubTitle && labelSubTitleHtml"
         class="subTitleHtml"
         [innerHTML]="labelSubTitleHtml | translate"></div>

    <div class="ng-content-wrapper">
        <ng-content></ng-content>
    </div>
</ng-template>
